import { Row, Col } from "antd";
import ScheduleForm from "./ScheduleForm";
import ScheduleImage from "./ScheduleImage";
import ScheduleInfo from "./ScheduleInfo";
import {
  ScheduleContainer,
  ScheduleFormContent,
  ScheduleFormContainer,
  ImageContainer,
} from "./styled";
import { SectionContainer } from "../../styled";

export default function Schedule({ description, image }) {
  return (
    <div>
      <ScheduleContainer>
        <Row gutter={50}>
          <Col xs={24} md={{ span: 12 }}>
            <SectionContainer>
              <ScheduleInfo description={description} />
            </SectionContainer>
          </Col>
          <Col xs={24} md={{ span: 12 }}>
            <ScheduleFormContainer>
              <ScheduleFormContent>
                <ScheduleForm />
              </ScheduleFormContent>
            </ScheduleFormContainer>
          </Col>
        </Row>
      </ScheduleContainer>
      <ImageContainer>
        <ScheduleImage image={image} />
      </ImageContainer>
    </div>
  );
}
